import React, { createContext, useContext, useState, useCallback } from "react";

// POS-only UI preferences (language + large text). Stored in localStorage.
// Scoped to the outlet POS shell — does NOT affect the admin sidebar or other pages.
// Purely presentational: no billing/order/stock logic depends on these values.

const DICT = {
  en: { new_order: "New Order", hold: "Hold", pay_cash: "Pay Cash", pay_upi: "Pay UPI", day_end: "Day End", table: "Table", qty: "Qty" },
  hi: { new_order: "नया ऑर्डर", hold: "होल्ड", pay_cash: "नकद", pay_upi: "यूपीआई", day_end: "दिन समाप्ति", table: "टेबल", qty: "मात्रा" },
  mr: { new_order: "नवीन ऑर्डर", hold: "होल्ड", pay_cash: "रोख", pay_upi: "यूपीआय", day_end: "दिवस समाप्ती", table: "टेबल", qty: "प्रमाण" },
};

export const POS_LANGS = [
  { v: "en", label: "English" },
  { v: "hi", label: "हिंदी" },
  { v: "mr", label: "मराठी" },
];

const DEFAULTS = {
  lang: "en",
  setLang: () => {},
  largeText: false,
  setLargeText: () => {},
  t: (key) => DICT.en[key] || key,
};

const PosPrefsContext = createContext(DEFAULTS);

export const PosPrefsProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const v = localStorage.getItem("pos-language");
    return DICT[v] ? v : "en";
  });
  const [largeText, setLargeTextState] = useState(() => localStorage.getItem("pos-large-text") === "1");

  const setLang = useCallback((l) => {
    const next = DICT[l] ? l : "en";
    localStorage.setItem("pos-language", next);
    setLangState(next);
  }, []);
  const setLargeText = useCallback((v) => {
    localStorage.setItem("pos-large-text", v ? "1" : "0");
    setLargeTextState(!!v);
  }, []);
  const t = useCallback((key) => (DICT[lang] && DICT[lang][key]) || DICT.en[key] || key, [lang]);

  return (
    <PosPrefsContext.Provider value={{ lang, setLang, largeText, setLargeText, t }}>
      {children}
    </PosPrefsContext.Provider>
  );
};

export const usePosPrefs = () => useContext(PosPrefsContext);
